module.exports = __webpack_public_path__ + "img/invoices.b2b6de63.svg";